import cnpj from "./validCpfCnpj/cnpj";
import cpf from "./validCpfCnpj/cpf";
export var formatDate = function (data) {
    var year = data.slice(0, 4);
    var month = data.slice(4);
    return "".concat(month, "/").concat(year);
};
export var formatCurrency = function (value) {
    if (!isNaN(Number(value))) {
        return Number(value).toLocaleString("pt-br", {
            style: "currency",
            currency: "BRL",
        });
    }
    return value;
};
export var formatForPayload = function (numero) {
    // Converte o número para string e separa a parte inteira da parte decimal
    var _a = numero.toFixed(2).split("."), parteInteira = _a[0], parteDecimal = _a[1];
    // Adiciona separador de milhar à parte inteira
    var parteInteiraFormatada = parteInteira.replace(/\d(?=(\d{3})+$)/g, "$&.");
    // Retorna a string formatada
    return "".concat(parteInteiraFormatada, ",").concat(parteDecimal);
};
export var somaDeValores = function (valorPrincipal, multa, juros, desconto) {
    return formatCurrency(valorPrincipal + multa + juros - desconto);
};
export var calcDataVencimento = function (dataVencimento) {
    var vencimentoDebito = convertFormatDateDMY(dataVencimento);
    var hoje = convertFormatDateDMY(new Date().toLocaleDateString("pt-br"));
    if (vencimentoDebito > hoje) {
        return dataVencimento;
    }
    return new Date().toLocaleDateString("pt-br");
};
export var convertFormatDateDMY = function (date) {
    if (date) {
        var d = date.trim().split(/\D+/g);
        return new Date(Number(d[2]), Number(d[1]) - 1, Number(d[0]));
    }
    return "";
};
export var formatCPFCNPJ = function (valor) {
    if (valor.length > 11) {
        var primeiraParte = valor.slice(0, 2);
        var segundaParte = valor.slice(2, 5);
        var terceiraParte = valor.slice(5, 8);
        var quartaParte = valor.slice(8, 12);
        var quintaParte = valor.slice(12, 14);
        var cnpj_1 = "".concat(primeiraParte, ".").concat(segundaParte, ".").concat(terceiraParte, "/").concat(quartaParte, "-").concat(quintaParte);
        var parteRestante = cnpj_1.slice(2);
        var asteriscos = "*".repeat(2);
        var ultimaParte = "".concat(asteriscos).concat(parteRestante).slice(0, -2);
        var teste = "*".repeat(2);
        return ultimaParte + teste;
    }
    else {
        var primeiraParte = valor.slice(0, 3);
        var segundaParte = valor.slice(3, 6);
        var terceiraParte = valor.slice(6, 9);
        var quartaParte = valor.slice(9, 11);
        var cpf_1 = "".concat(primeiraParte, ".").concat(segundaParte, ".").concat(terceiraParte, "-").concat(quartaParte);
        var novaString = cpf_1.substring(3, cpf_1.length - 2);
        return "***" + novaString + "**";
    }
};
export var paddingCpfCnpj = function (value) {
    if (cpf.isValid(value.padStart(11, "0"))) {
        return value.padStart(11, "0");
    }
    if (cnpj.isValid(value.padStart(14, "0"))) {
        return value.padStart(14, "0");
    }
    return value;
};
export var formatarBairro = function (bairro) {
    return bairro.replace(/[^ ]/g, "*");
};
export var formatarCep = function (cep) {
    return cep.replace(/^(\d{2})(\d{3})(\d{3})$/, "$1***-$3");
};
export var parse = function (obj) {
    try {
        if (typeof obj === "object") {
            return obj;
        }
        return JSON.parse(JSON.parse(JSON.stringify(obj)));
    }
    catch (error) {
        return {};
    }
};
export var completaZerosCnpj = function (cnpj) {
    var zeros = "00000000000000"; // String com 14 zeros
    return (zeros + cnpj).slice(-14); // Adiciona os zeros e retorna apenas os 14 últimos caracteres
};
export function getPeriodoReferencia() {
    var date = new Date();
    return "".concat(date.getFullYear()).concat(String(date.getMonth() + 1).padStart(2, "0"));
}
